export default __webpack_public_path__ + "static/media/musician.e6f416eb.jpg";